import { Component, OnDestroy } from '@angular/core';
import { takeWhile } from 'rxjs/operators';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'ra-router-loading-spinner',
  templateUrl: './router-loading-spinner.component.html',
  styleUrls: ['./router-loading-spinner.component.scss'],
  standalone: true,
})
export class RouterLoadingSpinnerComponent implements OnDestroy {
  isRouterLoading: 0 | 1 = 1;
  isAlive = true;

  constructor(
    private _router: Router,
  ) {
    this.listenRouteLoading();
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  listenRouteLoading() {
    this._router.events
      .pipe(takeWhile(() => this.isAlive))
      .subscribe((event) => {
        if (event instanceof NavigationStart) this.isRouterLoading = 1;
        else if (this.isRouterLoading == 0) return;
        else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        )
          this.isRouterLoading = 0;

        if (event instanceof NavigationError) {
          // this._popup.generateNotification('Ошибка загрузки страницы', 'error');
        }
      });
  }
}
